import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../LanguageContext";

function PrivacyBTScanner() {
  const { lang } = useLang();
  const isDE = lang === "de";

  return (
    <div className="dev-page">
      <div className="page-section-header">
        <span className="section-label">
          <Link to="/bluetooth-scanner" className="back-link">← BT/BLE-Scanner</Link>
        </span>
        <div className="subhead">{isDE ? "Datenschutzerklärung" : "Privacy Policy"}</div>
        <p className="section-intro-inner privacy-meta">
          BT/BLE-Scanner · Last updated: July 6, 2026
        </p>
      </div>

      <div className="privacy-content">
        <p>BT/BLE-Scanner ("the App") is developed and provided by Kai Steuernagel ("we", "us", "our"). This Privacy Policy explains what data the App processes — and, in short, why there is almost nothing to explain: the App does not collect any data.</p>

        <h2>1. Data Controller</h2>
        <div className="privacy-contact-card">
          <p><strong>Kai Steuernagel</strong></p>
          <p>Email: <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a></p>
          <p>Website: <a href="https://www.steuernagel.net">www.steuernagel.net</a></p>
        </div>

        <h2>2. No Data Collection</h2>
        <p>The App is designed to work entirely offline. We do not collect, store, transmit, sell, or analyze any personal data, because the App has no backend and no internet connectivity to do so. Specifically:</p>
        <ul>
          <li>No account, registration, or sign-in is required or offered.</li>
          <li>No personal data is transmitted to us or to any third party.</li>
          <li>No analytics, crash reporting, advertising, or tracking SDKs are integrated.</li>
          <li>No internet connection is required or used by the App at any point.</li>
          <li>No location data is requested or accessed.</li>
        </ul>

        <h2>3. Bluetooth Usage</h2>
        <p>The App uses Bluetooth Low Energy (BLE) exclusively to discover and read advertisement data from Bluetooth devices in range of your iPhone — for example device names, signal strength (RSSI), service identifiers, and manufacturer data. This happens entirely locally on your device.</p>
        <p>There is no server in between — we do not operate one, and the App does not connect to one. iOS will request Bluetooth permission the first time you launch the App or start a scan; this permission is used only to enable the local scanning described above.</p>

        <h2>4. Data Stored on Your Device</h2>
        <p>Devices you scan or add to your list exist only for your current session — this data is held in memory and is cleared automatically when you close the App. It is never written to disk and never leaves your device.</p>
        <p>Your display preferences — dark/light mode and scan settings (auto-stop timer, hide-unnamed filter, minimum signal strength) — are stored locally on your device only, using standard iOS storage mechanisms, so they are remembered the next time you open the App. This data never leaves your device and is not accessible to us.</p>
        <p>If you use the App's export feature, a JSON file containing your currently saved devices is created temporarily on your device so it can be shared or saved via the standard iOS share sheet, entirely under your control.</p>

        <h2>5. Third Parties</h2>
        <p>The App does not share data with third parties, since no data is collected in the first place. The App can discover any Bluetooth LE device that advertises itself nearby and is not affiliated with, endorsed by, or otherwise connected to the manufacturer of any device it may display.</p>

        <h2>6. Children's Privacy</h2>
        <p>The App does not knowingly collect data from anyone, including children, because it does not collect personal data from any user regardless of age.</p>

        <h2>7. Changes to This Policy</h2>
        <p>We may update this Privacy Policy occasionally, for example to reflect changes to the App's functionality. Any changes will be posted on this page with an updated "Last updated" date above.</p>

        <h2>8. Contact</h2>
        <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:developer@steuernagel.net">developer@steuernagel.net</a>.</p>

        <p className="privacy-footer">© Kai Steuernagel — BT/BLE-Scanner</p>
      </div>
    </div>
  );
}

export default PrivacyBTScanner;
